/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { UI_RESOURCES } from '@shared/utils';
 * 
 * // Use UI resource constants
 * const resource = UI_RESOURCES.BUTTON;
 * ```
 */
export const UI_RESOURCES = {

} as const;